'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _shopifySectionsManager = require('shopify-sections-manager');

var _shopifySectionsManager2 = _interopRequireDefault(_shopifySectionsManager);

var _StaticPage = require('../sections/StaticPage');

var _StaticPage2 = _interopRequireDefault(_StaticPage);

var _PageFeatures = require('../sections/PageFeatures');

var _PageFeatures2 = _interopRequireDefault(_PageFeatures);

require('intersection-observer');

var _rimgShopify = require('rimg-shopify');

var _rimgShopify2 = _interopRequireDefault(_rimgShopify);

require('../../styles/templates/page.scss');

require('../../styles/templates/index.scss');

require('../../styles/sections/page-features.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = function Page() {
  (0, _classCallCheck3.default)(this, Page);

  var sections = window.shopifySections || new _shopifySectionsManager2.default();
  sections.register('static-page', function (section) {
    return new _StaticPage2.default(section);
  });
  sections.register('page-features', function (section) {
    return new _PageFeatures2.default(section);
  });

  _rimgShopify2.default.init();
};

exports.default = Page;


new Page();